import React from "react";
import { Dispatch } from "redux";

interface InputProps {
  label: string;
  type?: string;
  id: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  value?: string;
}

export const Input = ({
  label,
  type = "text",
  id,
  onChange,
  value = "",
}: InputProps) => {
  return (
    <div>
      <label htmlFor={id} className="block text-sm font-medium text-stone-600">
        {label}
      </label>
      <div className="mt-1">
        <input
          id={id}
          name={id}
          type={type}
          onChange={onChange}
          value={value}
          className="block w-full rounded-md border-stone-300 py-3 px-4 text-stone-900 shadow-sm focus:border-primary-500 focus:ring-primary-500"
        />
      </div>
    </div>
  );
};

interface TextAreaProps {
  onChange: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
  value?: string;
}
export const TextArea = ({ onChange, value = "" }: TextAreaProps) => {
  return (
    <div className="sm:col-span-2">
      <div className="flex justify-between">
        <label
          htmlFor="message"
          className="block text-sm font-medium text-stone-900"
        >
          Message
        </label>
        <span id="message-max" className="text-sm text-stone-500">
          Max. 500 characters
        </span>
      </div>
      <div className="mt-1">
        <textarea
          id="message"
          name="message"
          rows={4}
          value={value}
          className="block w-full rounded-md border-stone-300 py-3 px-4 text-stone-900 shadow-sm focus:border-primary-500 focus:ring-primary-500"
          aria-describedby="message-max"
          defaultValue={""}
          onChange={onChange}
        />
      </div>
    </div>
  );
};
